module.exports = __webpack_public_path__ + "static/media/12-speaker_profile.606e134a.webp";